export const applyForm = 'https://docs.google.com/forms/d/e/1FAIpQLSe2vRp96FN1OJfpOaXc9SLmt3cSf1-2RlE4kaAe708y3SQf-Q/viewform';

export default { applyForm };
